module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    key: "facebookDialog",
    attrs: {
      "title": "Create Facebook Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Facebook'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loader-text"
  }, [_vm._v("\n      Waiting for authorization.\n      "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]), _vm._v(" "), (_vm.facebookPages.length !== 0) ? _c('div', {
    staticClass: "facebook-pages"
  }, [_c('p', [_vm._v("Choose Page(s)")]), _vm._v(" "), _c('div', {
    staticClass: "page-list"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.selectedPages),
      callback: function($$v) {
        _vm.selectedPages = $$v
      },
      expression: "selectedPages"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('div', {
      key: page.page_id
    }, [_c('el-checkbox', {
      attrs: {
        "label": page.page_id
      }
    }, [_vm._v(_vm._s(page.page_name))])], 1)
  }), 0)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSaving || !_vm.selectedPages.length,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.isSaving) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb4c0656","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/facebook/FacebookCreateDialog.vue
// module id = 3394
// module chunks = 3